import React, { Fragment } from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import { compose, lifecycle, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import LoansList from './LoansList';
import {
  canShowNoOfferView,
  canUseStripeCapitalFinancing,
  getActiveLoansList,
  isInitialLoansLoadDone,
} from './selectors';

const LoansRouteChecker = compose(
  withRouter,
  connect(state => ({
    canSeeStripeCapitalFinancing: canUseStripeCapitalFinancing(state),
    initialLoansLoadDone: isInitialLoansLoadDone(state),
    hasLoansToShow: canShowNoOfferView(state) || getActiveLoansList(state).length > 0,
  })),
  withPropsOnChange(['initialLoansLoadDone'],
    (props) => {
      if (props.initialLoansLoadDone && !props.hasLoansToShow) {
        props.router.push('/');
      }
    }
  ),
  lifecycle({
    componentDidMount() {
      if (!this.props.canSeeStripeCapitalFinancing) {
        this.props.router.push('/');
      }
    },
  })
)(({ children }) => (<Fragment>{children}</Fragment>));

const LoansRoutes = () => (
  <Route path="financing" name="financing" component={LoansRouteChecker}>
    <IndexRoute component={LoansList} />
  </Route>
);

export default LoansRoutes;
